// extracted by mini-css-extract-plugin
export default {"brandPromo":"HG-z","carousel":"IG-z"};